:host{width:24px;height:24px}
/*# sourceMappingURL=zoom-panel-cursor.component.css.map */
